import { Link } from "react-router-dom";
import { ArrowRight, ClipboardCheck } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Reveal } from "@/components/Reveal";
import { useAssessment } from "@/context/AssessmentContext";
import { IMG } from "@/data/content";

export default function AssessmentBanner() {
  const { openAssessment } = useAssessment();
  return (
    <section className="bg-white py-8" data-testid="assessment-banner">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <Reveal className="relative overflow-hidden rounded-3xl border border-line">
          <img src={IMG.villa} alt="Luxury villa" className="absolute inset-0 h-full w-full object-cover" loading="lazy" />
          <div className="absolute inset-0 bg-gradient-to-r from-navy/95 via-navy/80 to-navy/40" />
          <div className="relative flex flex-col items-start gap-6 p-10 lg:flex-row lg:items-center lg:justify-between lg:p-14">
            <div className="max-w-2xl">
              <span className="eyebrow text-sky">Free Property Assessment</span>
              <h2 className="mt-3 font-serif text-3xl font-bold text-white sm:text-4xl">See where your property can grow — at no cost.</h2>
              <p className="mt-4 text-white/75">Share a few details about your property and we'll identify the right platforms and services to strengthen your online presence.</p>
            </div>
            <div className="flex shrink-0 flex-col gap-3 sm:flex-row lg:flex-col">
              <Button onClick={openAssessment} data-testid="banner-assessment-cta" className="rounded-full bg-sky px-8 py-6 text-base font-semibold text-navy hover:bg-sky-light">
                <ClipboardCheck className="h-5 w-5" /> Get a Free Assessment
              </Button>
              <Button asChild variant="outline" className="rounded-full border-white/40 bg-white/5 px-8 py-6 text-base text-white backdrop-blur-md hover:bg-white/15 hover:text-white" data-testid="banner-list-cta">
                <Link to="/list-your-property">List Your Property <ArrowRight className="h-4 w-4" /></Link>
              </Button>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
